import { cn } from "@/lib/utils";

interface PageLoaderProps {
  className?: string;
  text?: string;
  /** Overlay plein écran (suspense routes). Sinon : indicateur centré dans le conteneur. */
  fullScreen?: boolean;
}

/**
 * Indicateur de chargement marqué Equiply — vrai logo en pulse au-dessus
 * d'une barre fine indéterminée. Apparition différée (160 ms) pour éviter
 * tout flash sur les chunks rapides.
 */
export function PageLoader({ className, text, fullScreen = false }: PageLoaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 motion-loader-reveal",
        fullScreen
          ? "fixed inset-0 min-h-screen bg-background/40 backdrop-blur-sm z-50"
          : "w-full py-10 min-h-[40vh]",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <img
        src="/Logosansmarque.webp"
        alt=""
        width={72}
        height={72}
        decoding="async"
        className="w-[72px] h-[72px] motion-logo-pulse"
        aria-hidden="true"
      />
      <div
        className="relative h-0.5 w-[280px] overflow-hidden rounded-full bg-foreground/8"
        aria-hidden="true"
      >
        <div className="absolute inset-y-0 left-0 w-[35%] bg-gradient-to-r from-transparent via-primary to-transparent motion-progress-indeterminate" />
      </div>
      {text && (
        <p className="text-payfit-body text-muted-foreground">{text}</p>
      )}
      <span className="sr-only">Chargement de la page...</span>
    </div>
  );
}
